// mui
import { Button, Grid, Stack, Typography } from '@mui/material';
// form
import { useFieldArray, useForm } from 'react-hook-form';
// little-state-machine
import { useStateMachine } from 'little-state-machine';
import { defaultLocationObject } from '../../../../store/form/state/locations';
// component
import { FormProvider, FieldCondition } from '../../../../components/hook-form';
import FormSectionControls from '../../FormSectionControls';
import Iconify from '../../../../components/iconify/Iconify';
// hooks
import useFormStateUpdateOnChange from '../../../../hooks/useFormStateUpdateOnChange';
import LocationFields from './fields/LocationFields';

// -------------------------------------------------------

const Form = () => {
  const maxLocations = 3;

  // state
  const { state } = useStateMachine();

  // form
  const methods = useForm({
    mode: 'onChange',
    defaultValues: state.form,
  });

  const { watch, control } = methods;

  useFormStateUpdateOnChange(watch);

  const {
    fields: locations,
    append: appendLocation,
    remove: removeLocation,
  } = useFieldArray({
    control,
    name: 'locations',
    defaultValues: state.form.locations,
  });

  const handleAppendLocation = () => appendLocation({...defaultLocationObject, locNumber: (methods.getValues('locations').length + 1).toString()});
  const handleRemoveLocation = (index) => (locations?.length > 1 ? removeLocation(index) : null);

  return (
    <FormProvider methods={methods}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack spacing={2}>
            {locations?.map(({ id }, idx) => (
              <LocationFields
                onRemove={handleRemoveLocation}
                isRemoveDisabled={locations?.length === 1}
                index={idx}
                key={id}
              />
            ))}
          </Stack>
        </Grid>

        <FieldCondition fieldName="locations" condition={(val) => val.length < maxLocations}>
          <Grid item xs={12}>
            <Stack alignItems={'flex-end'} direction={'column'}>
              <Button
                variant={'text'}
                onClick={handleAppendLocation}
                endIcon={<Iconify icon="eva:plus-fill" width={25} height={25} />}
              >
                Add Location
              </Button>
            </Stack>
          </Grid>
        </FieldCondition>
        <FieldCondition fieldName="locations" condition={(val) => val.length >= maxLocations}>
          <Grid item xs={12}>
            <Stack alignItems={'center'}>
              <Typography fontSize={15}>
                If more than {maxLocations} locations, please attach a list of locations.
              </Typography>
            </Stack>
          </Grid>
        </FieldCondition>
      </Grid>

      <FormSectionControls step={'locations'} />
    </FormProvider>
  );
};

export default Form;
